import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from './components/common';
import reportWebVitals from './reportWebVitals';
import RootRoute from './routes';
import { AuthProvider } from './store/AuthContext';
import './styles/index.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <RootRoute />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
